import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=32e38918&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e38918",
  null
  
)

export default component.exports